import React, { useEffect, useMemo, useState, useRef } from "react";
import AdminHeading from "Components/Pages/AdminPanel/Heading/AdminHeading";
import html2canvas from "html2canvas";
import Slider from "react-slick";
import { FaPencil } from "react-icons/fa6";


import PageLoader from "Components/PageLoader";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchLabelledStocks } from "services/stockService";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import CustomerTable from "Components/support/customervendor/customer";
import { selectStyle, selectStylee, stockListColumns } from "utils/helpers";
import { Icon } from "@iconify/react";
import AdminBreadCrump from "Components/Pages/AdminPanel/Heading/AdminBreadCrump";
import useScreenSize from "hooks/useScreenSize";
import ErrorModal from "Components/Other Functions/popup";
import { ClipLoader } from "react-spinners";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { useNavigate } from "react-router-dom";
import LabelledStockList from "../../Trading/LabelledStockList";
import { FaBoxes, FaImage, FaList } from "react-icons/fa";
import { LuLayoutGrid } from "react-icons/lu";
import { BsGridFill } from "react-icons/bs";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { fetchAllCategory } from "services/other";
import {
  fetchAllCategories,
  fetchAllDesigns,
  fetchAllLabelledStockFilter,
  fetchAllProducts,
  fetchDataTotalCount,
} from "services/generalService";
import { GenerateLabel } from "Components/Other Functions/GenerateLabel";
import jsPDF from "jspdf";
import "./Filter.css";
import style from "../../Trading/LabelledStockList.module.css";
import LabelledStockListNew from "../../Trading/LabelledStockListNew";
import useDebounce from "hooks/useDebounce";
import ProductCarousel from "Components/AddStock/ProductCarousel";
import StockInGrid from "../../Trading/StockInGrid";
import exportToExcel from "Components/CommonComponents/ExcelDownload";

export default function InventoryList() {
  const navigate = useNavigate();
  const isSmallScreen = useScreenSize();
  const [isGrid, setIsGrid] = useState(false);
  const [loader, setLoader] = useState(false);
  const [list2, setList2] = useState([]);

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);

  const dbname = adminLoggedIn.Clients.OrganisationName;

  const [selectedItems, setSelectedItems] = useState([]);

  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebounce(searchInput,2000)


  const pdfRef = useRef(null);



  const generatePdf = async () => {
    if (!pdfRef.current) return;
    setLoader(true);

    try {
      // **STEP 1: Scroll entire div into view to ensure images load**
      pdfRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

      // **STEP 2: Wait for 1 second to let off-screen images load**
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // **STEP 3: Capture the full div including off-screen images**
      const canvas = await html2canvas(pdfRef.current, {
        scale: 2, // High quality
        useCORS: true, // Allow external images
        allowTaint: true, // Allow cross-origin images
        logging: true, // Enable logging for debugging
        windowWidth: document.documentElement.scrollWidth, // Capture full width
        windowHeight: document.documentElement.scrollHeight, // Capture full height
      });

      // Convert to image
      const imgData = canvas.toDataURL("image/png");

      console.log(imgData);
      

      // Get dynamic component size
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Create PDF dynamically sized to the content
      const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("Catalouge.pdf");
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error generating PDF:", error);
    }
  };




  
  

  

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const [rowsPerPages, setRowsPerPages] = useState(25); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const { data: CategoryList } = useQuery({
    queryKey: ["stock/categoryList", clientCode],
    queryFn: fetchAllCategories,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  const { data: ProductList } = useQuery({
    queryKey: ["stock/ProductList", clientCode],
    queryFn: fetchAllProducts,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
  });
  const { data: DesignList } = useQuery({
    queryKey: ["stock/DesignList", clientCode],
    queryFn: fetchAllDesigns,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
  });

  const { data: DataTotalCount } = useQuery({
    queryKey: ["stock/DataTotalCount", clientCode],
    queryFn: fetchDataTotalCount,
    refetchOnWindowFocus: false,
  });

  const { register, control, watch, setValue } = useForm({
    defaultValues: {
      fromDate: null,
      toDate: null,
      Page: 1,
    },
  });
  const [selectedAll, setSelectedAll] = useState([]);
  const [PageNumber, setPageNumber] = useState(1);

  const [PageSize, setPageSize] = useState(25);
  const [InputPageNumber, setInputPageNumber] = useState();
  const [exportOpen, setExportOpen] = useState(false);
  const deboncedInputPageNumber = useDebounce(InputPageNumber, 1000);

  const categoryName = watch("categoryName");
  const productName = watch("productName");
  const designName = watch("designName");
  const fromDate = watch("fromDate");
  const toDate = watch("toDate");

  const Content = "";

  const {
    data: LabelledList,
    isError,
    isPending: isLoading,
    mutate,
  } = useMutation({ mutationFn: fetchAllLabelledStockFilter });

  useEffect(() => {
    mutate({
      ClientCode: clientCode,
      CategoryId: +(categoryName?.value || 0),
      ProductId: +(productName?.value || 0),
      DesignId: +(designName?.value || 0),
      FromDate: fromDate,
      ToDate: toDate,
      ItemCode: "",
      // Content:"",
      Status: "Active",
      pageNumber: PageNumber,
      pageSize: PageSize,
      SearchQuery:debouncedSearch
    });
  }, [PageNumber]);

  useEffect(() => {
    if(PageNumber != 1){
      setPageNumber(1);
    }else{
      mutate({
        ClientCode: clientCode,
        CategoryId: +(categoryName?.value || 0),
        ProductId: +(productName?.value || 0),
        DesignId: +(designName?.value || 0),
        FromDate: fromDate,
        ToDate: toDate,
        ItemCode: "",
        // Content:"",
        Status: "Active",
        pageNumber: PageNumber,
        pageSize: PageSize,
        SearchQuery:debouncedSearch
      });
    }
  }, [categoryName, productName, designName, fromDate, toDate,debouncedSearch, PageSize]);
  // const {
  //   data: LabelledList,
  //   isLoading,
  //   isError,
  //   error,
  // } = useQuery({
  //   queryKey: [
  //     "stock/getLabelledList",
  //     clientCode,
  //     categoryName?.value || 0,
  //     productName?.value || 0,
  //     designName?.value || 0,
  //     fromDate,
  //     toDate,
  //     Content,
  //     Page,
  //     PageSize,
  //   ],
  // queryFn: fetchLabelledStocks,
  //   refetchOnWindowFocus: false,
  //   cacheTime: 1000 * 60 * 1,
  //   staleTime: 1000 * 60 * 1,
  // });

  useEffect(() => {
    if (deboncedInputPageNumber) {
      setPageNumber(deboncedInputPageNumber);
      setInputPageNumber();
    }
  }, [deboncedInputPageNumber]);

  useEffect(() => {
    if (isError) {
      toast.error(error?.message, {
        position: "top-center",
        duration: 3000,
      });
    }
  }, [isError]);

  const list = useMemo(() => {
    return LabelledList?.length
      ? LabelledList?.map((item) => {
          return {
            ...item,
            GrossWt: (+(item?.GrossWt || 0))?.toFixed(3),
            TotalStoneWeight: (+(item?.TotalStoneWeight || 0))?.toFixed(3),
            NetWt: (+(item?.NetWt || 0))?.toFixed(3),
            TotalStoneAmount: (+(item?.TotalStoneAmount || 0))?.toFixed(2),
            MRP: (+(item?.MRP || 0))?.toFixed(2),
            MakingFixedWastage: (+(item?.MakingFixedWastage || 0))?.toFixed(2),
            MakingFixedAmt: (+(item?.MakingFixedAmt || 0))?.toFixed(2),
            ClipWeight: (+(item?.ClipWeight || 0))?.toFixed(2),
          };
        })
      : [];
  }, [LabelledList]);

  const printLabel = async (products) => {
    try {
      const res = await GenerateLabel(products, labelFormat);
    } catch (error) {
      toast?.error(
        "You do not have a label assigned. Please contact your administrator for assistance.",
        {
          duration: 4000,
          position: "top-center",
        }
      );
      console.log(error);
    }
  };

  const printList = () => {
    if (!selectedAll?.length) {
      toast.error("Please select items from list", {
        position: "top-center",
        duration: 2000,
      });
    } else {
      printListAll(selectedAll);
    }
  };

 const handlePrintLable = ()=>{
  if (!selectedAll?.length) {
    toast.error("Please select items from list", {
      position: "top-center",
      duration: 2000,
    });
  } else {
    console.log(selectedAll)
    printLabel(selectedAll);
  }
 }

  const printListAll = async (data) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const startX = 10; // Adjusted startX value for the serial number column
    let startY = 20;
    const lineHeight = 5;
    const margin = 5;
    const serialNumberWidth = 20; // Width for the serial number column
    const columnWidth =
      (pageWidth - startX - serialNumberWidth - 10 * margin) / 10;

    doc.setFont("helvetica", "normal");
    // doc.setFontSize(12);
    doc.setFontSize(8);

    const generateHeader = () => {
      doc.text("S. No.", startX, startY); // Serial Number
      doc.text("Design Name", startX + columnWidth, startY);
      doc.text("SKU", startX + 3 * columnWidth, startY);
      doc.text("Gross Wt", startX + 4.2 * columnWidth, startY);
      doc.text("Net Wt", startX + 5.3 * columnWidth, startY);
      doc.text("Item Code", startX + 6.5 * columnWidth, startY);
      doc.text("Barcode No", startX + 8 * columnWidth, startY);
      // doc.text("M Fixed Amt", startX + 7 * columnWidth, startY);
      // doc.text("M Fix Wastage", startX + 8.5 * columnWidth, startY);
      // doc.text("M Percentage", startX + 10 * columnWidth, startY);
      // doc.text("M per_gram", startX + 11.5 * columnWidth, startY);
      // doc.text("stoneAmount", startX + 13 * columnWidth, startY);
      doc.text("Tid", startX + 9.5 * columnWidth, startY);
    };
    const totalNetWt = data.reduce(
      (total, item) => total + (parseFloat(item.netWt) || 0),
      0
    );
    const totalGrossWt = data.reduce(
      (total, item) => total + (parseFloat(item.grosswt) || 0),
      0
    );
    // Generate header on the first page
    generateHeader();
    // doc.text(
    //     `Total Net Wt: ${totalNetWt.toFixed(3)} gm`,
    //     startX + 5 * columnWidth,
    //     startY - 10
    // );
    // doc.text(
    //     `Total Gross Wt: ${totalGrossWt.toFixed(3)} gm`,
    //     startX,
    //     startY - 10
    // );
    // Generate data rows

    let y = startY + lineHeight + margin;
    data.forEach((item, index) => {
      // Check if we need to start a new page
      if (index > 0 && y + lineHeight > pageHeight - margin) {
        doc.addPage();
        startY = 20; // Reset startY for the new page
        // Generate header on each new page
        generateHeader();
        y = startY + lineHeight + margin; // Update y position for the new page
      }

      const serialNumber = index + 1;
      doc.text(serialNumber.toString(), startX, y);
      doc.text(
        item.DesignName ? item.DesignName.toString().substr(0, 8) : "N/A",
        startX + columnWidth,
        y
      );
      doc.text(
        item.SKU ? item.SKU.toString() : "N/A",
        startX + 3 * columnWidth,
        y
      );
      doc.text(
        item.GrossWt ? item.GrossWt.toString() : "N/A",
        startX + 4.2 * columnWidth,
        y
      );
      doc.text(
        item.NetWt ? item.NetWt.toString() : "N/A",
        startX + 5.3 * columnWidth,
        y
      );
      doc.text(
        item.ItemCode ? item.ItemCode.toString() : "N/A",
        startX + 6.5 * columnWidth,
        y
      );
      // doc.text(
      //   item.making_Fixed_Amt ? item.making_Fixed_Amt.toString() : "N/A",
      //   startX + 7 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.making_Fixed_Wastage
      //     ? item.making_Fixed_Wastage.toString()
      //     : "N/A",
      //   startX + 8.5 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.making_Percentage ? item.making_Percentage.toString() : "N/A",
      //   startX + 10 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.making_per_gram ? item.making_per_gram.toString() : "N/A",
      //   startX + 11.5 * columnWidth,
      //   y
      // );
      // doc.text(
      //   item.stoneAmount ? item.stoneAmount.toString() : "N/A",
      //   startX + 13 * columnWidth,
      //   y
      // );
      doc.text(
        item.BranchName ? item.BranchName.toString() : "N/A",
        startX + 8 * columnWidth,
        y
      );
      doc.text(
        item.TIDNumber ? item.TIDNumber.toString() : "N/A",
        startX + 9.5 * columnWidth,
        y
      );
      y += lineHeight + margin;
    });

    // Add page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.text(`Page ${i} of ${totalPages}`, pageWidth - 50, pageHeight - 10);
    }

    // Get PDF data as Uint8Array
    const pdfData = doc.output();

    // Create a new Blob from the PDF data
    const pdfBlob = new Blob([pdfData], { type: "application/pdf" });

    // Create a URL from the Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfUrl, "_blank");
  };

  const filteredData = searchInput
    ? list?.filter((items) =>
        Object.values(items)?.some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    : list;

  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if(LabelledList?.length){
      const result = Math.ceil((+LabelledList[0]?.TotalCount || 0) / PageSize);
      setTotalPages(result);
    }else{
      setTotalPages(1)
    }
    
  }, [LabelledList, PageSize]);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  // Smart Pagination Logic
  const generatePagination = () => {
    let pages = [];
    let maxPagesToShow = 0;

    if (totalPages <= maxPagesToShow) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      pages.push(1);

      if (PageNumber > 5) {
        pages.push("...");
      }

      let start = Math.max(2, PageNumber - 1);
      let end = Math.min(totalPages - 1, PageNumber + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (PageNumber < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return pages;
  };
  const startIndex = (currentPage - 1) * PageSize;
  const displayedData = filteredData?.slice(startIndex, startIndex + PageSize);

  const preprocessedData = displayedData?.map((product, idx) => ({
    ...product,
    Id: product.Id !== undefined ? product.Id : `temp-id-${idx}`,
    serialNumber: startIndex + idx + 1, // Serial number
  }));

  useEffect(() => {
    if (preprocessedData?.length && selectedItems?.length) {
      const filtered = [];
      selectedItems?.forEach((item) => {
        let found = preprocessedData?.find((pItem) => pItem?.Id == item);
        if (found) {
          filtered.push(found);
        }
      });
      setSelectedAll(filtered);
    } else {
      setSelectedAll([]);
    }
  }, [selectedItems]);


  const settings = {
    dots: true,        
    infinite: false,    
    speed: 500,        
    slidesToShow: 1,    
    slidesToScroll: 1,  
    autoplay: false,   
    
  };


  

  
  
  

   const DownloadExcel = (data)=>{
      const headers = {
        'S.No': null, // Auto-generated
        // 'Date': 'InvoiceNo',
        'Item Code': 'ItemCode',
        'RFID Code': 'RFIDCode',
        'Product Code': 'ProductCode',
        'SKU': 'SKU',
        'Category Name': 'CategoryName',
        'Product': 'ProductName',
        'Design': 'DesignName',
        'Purity Name': 'ProductName',
        'Gross Wt': 'GrossWt',
        'Stone Wt': 'TotalStoneWeight',
        'Stone Pcs': 'TotalStonePieces',
        'Diamond Wt': 'TotalDiamondWeight',
        'Diamond Pcs': 'TotalDiamondPieces',
        'Net Wt': 'NetWt',
        'Pieces': 'Pieces',
        'Stone Amt': 'TotalStoneAmount',
        'MRP': 'MRP',
        'Fixed Wastage': 'MRP',
        'Fixed Amt': 'MakingFixedAmt',
        'Packet': 'PacketName',
        'Clip Wt': 'ClipWeight',
        'Box Name': 'BoxName',
        'Vendor': 'VendorName',
        'Branch': 'BranchName',
       
      };
      console.log(data)
      exportToExcel(data, headers, 'InventoryList.xlsx');
    }

  return (
    <>
      <div>
        <AdminHeading />
        {isLoading && <PageLoader />}

        {false ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={false} />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            <div>
              <ErrorModal
                isOpen={false}
                onRequestClose={() => {
                  // setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={() => {}} // Pass reload function
                message={""}
              />

              <div className="adminMainBodyBox">
                {false ? <AlertMessage message={""} type={null} /> : null}
              </div>
            </div>
          </>
        )}
        {loader && <PageLoader />}
        <AdminBreadCrump
          title={`${"Labelled Stock List"}`}
          companyName={"Loyalstring"}
          module={"Transactions"}
          page={`${"Labelled Stock List"}`}
        />
      </div>
      <div style={{ padding: "2px 20px" }}>
        <div
          style={{
            display: "flex",
            gap: "15px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            background: "#fff",
            padding: "10px",
          }}
        >
          <Controller
            name={"categoryName"}
            control={control}
            render={({ field: controllerField }) => {
              return (
                <Select
                  {...controllerField}
                  options={
                    CategoryList?.length &&
                    CategoryList?.map((item) => {
                      return { value: item?.Id, label: item?.CategoryName };
                    })
                  }
                  isSearchable={true}
                  placeholder={"Category Name"}
                  isClearable={true}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "180px", // Set a fixed width (adjust as needed)
                      minWidth: "180px", // Prevent shrinking
                      maxWidth: "180px", // Prevent expanding
                    }),
                    menu: (base) => ({
                      ...base,
                      width: "180px", // Ensure the dropdown matches the select width
                    }),
                  }}
                />
              );
            }}
          />

          <Controller
            name={"productName"}
            control={control}
            render={({ field: controllerField }) => {
              return (
                <Select
                  {...controllerField}
                  options={
                    ProductList?.length &&
                    ProductList?.map((item) => {
                      return { value: item?.Id, label: item?.ProductName };
                    })
                  }
                  isSearchable={true}
                  placeholder={"Product Name"}
                  isClearable={true}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "180px", // Set a fixed width (adjust as needed)
                      minWidth: "180px", // Prevent shrinking
                      maxWidth: "180px", // Prevent expanding
                    }),
                    menu: (base) => ({
                      ...base,
                      width: "180px", // Ensure the dropdown matches the select width
                    }),
                  }}
                />
              );
            }}
          />

          <Controller
            name={"designName"}
            control={control}
            render={({ field: controllerField }) => {
              return (
                <Select
                  {...controllerField}
                  options={
                    DesignList?.length &&
                    DesignList?.map((item) => {
                      return { value: item?.Id, label: item?.DesignName };
                    })
                  }
                  isSearchable={true}
                  placeholder={"Design Name"}
                  isClearable={true}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "180px", // Set a fixed width (adjust as needed)
                      minWidth: "180px", // Prevent shrinking
                      maxWidth: "180px", // Prevent expanding
                    }),
                    menu: (base) => ({
                      ...base,
                      width: "180px", // Ensure the dropdown matches the select width
                    }),
                  }}
                />
              );
            }}
          />

          <input
            type="date"
            {...register("fromDate")}
            style={{ width: "16%", height: "38px" }}
          />
          <input
            type="date"
            {...register("toDate")}
            style={{ width: "16%", height: "38px" }}
          />

          {isGrid ? (
            <BsGridFill
              type={"button"}
              onClick={() => setIsGrid(false)}
              style={{
                fontSize: "28px ",
                color: "#0077d4",
                cursor: "pointer",
              }}
            />
          ) : (
            <FaList
              type={"button"}
              onClick={() => setIsGrid(true)}
              style={{
                fontSize: "28px ",
                color: "#0077d4",
                cursor: "pointer",
              }}
            />
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              // value={searchInput}
              onChange={handleSearchChange}
              placeholder="Search..."
              style={{
                border: "1px solid gray",
                borderRadius: "0px",
                borderBottomLeftRadius: "8px",
                borderTopLeftRadius: "8px",
                height: "34px",
              }}
              // className={style["serach-input"]}
            />

            <Icon
              style={{
                fontSize: "20px",
                padding: "7px",
                background: "#0077D4",
                color: "#fff",
                height: "20px",
                width: "20px",
                borderBottomRightRadius: "8px",
                borderTopRightRadius: "8px",
              }}
              icon="mdi:magnify"
            />
          </div>

          <div style={{ position: "relative", display: "inline-block" }} 
          // ref={dropdownRef}
          >
      <Icon
        onClick={() => setExportOpen(!exportOpen)}
        style={{
          fontSize: "40px",
          color: "#0077d4",
          cursor: "pointer",
        }}
        icon="bx:export"
      />
      {exportOpen && (
       <div
       style={{
         position: "absolute",
         top: "45px",
         right: "0",
         backgroundColor: "#fff",
         border: "1px solid #e0e0e0",
         borderRadius: "6px",
         boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
         zIndex: 10,
         minWidth: "150px",
         overflow: "hidden",
       }}
     >
       <div
      onClick={printList}        
      style={{
           padding: "10px 16px",
           cursor: "pointer",
           whiteSpace: "nowrap",
           transition: "background-color 0.2s ease",
         }}
         onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5faff")}
         onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
       >
         📄 Export PDF
       </div>
       <div
         onClick={()=>DownloadExcel(list)}
         style={{
           padding: "10px 16px",
           cursor: "pointer",
           whiteSpace: "nowrap",
           transition: "background-color 0.2s ease",
         }}
         onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5faff")}
         onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
       >
         📊 Export Excel
       </div>
     </div>
     
      )}
    </div>

          {/* <Icon
            onClick={() => generatePdf()}
            style={{
              fontSize: "40px ",
              color: "#0077d4",
              cursor: "pointer",
            }}
            icon="bx:export"
          /> */}

          <button
            // style={{ width: "30%" }}
            // className={style["custom-btn"]}
            // onClick={handlePrintRdPurchase}
            onClick={handlePrintLable}
            
          >
            <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
            Print
          </button>
          <button
            //  onClick={handlenew}
            onClick={() => navigate("/add_stock_labelled_unlabelled?stockType=Labelled")}
            style={{ margin: 0 }}
            // className={style["custom-btn"]}
          >
            New
            <Icon icon="mdi:plus" width="24" height="24" />
          </button>
        </div>

        {isGrid ? (
          <>
            <div
            id="pdfCapture"
            ref={pdfRef}
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "20px",
                padding: "20px",
              }}
            >
              {list?.length
                ? list.map((item) => {
                    let imageArray = item?.Images?.length
                      ? item.Images.split(",")
                      : [];
                    return (
                      // <ProductCarousel
                      //   key={item.SKU}
                      //   imageArray={imageArray}
                      //   product={item}
                      //   pdfRef={pdfRef}
                      // />

                       <div
                          
                     
                            style={{
                              width: "100%",
                              background: "#fff",
                              borderRadius: "12px",
                              overflow: "hidden",
                              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center",
                              height: "100%",
                              cursor:"pointer"
                            }}
                            // onClick={()=> navigate(`/edit_stock_labelled_unlabelled/${product?.Id}`)}
                          >
                            <div style={{ width: "100%", padding:"20px",position:'relative' }}>
                              <FaPencil style={{position:"absolute",top:"10",right:"30",zIndex:"99",color:"gray"}}
                              onClick={()=> navigate(`/edit_stock_labelled_unlabelled/${item?.Id}`)}
                              />
                              {imageArray?.length > 0 ? (
                                <Slider {...settings}>
                                  {imageArray.map((image, index) => (
                                    <div key={index} style={{ padding: "20px" }}>
                                      <img
                                      //  crossOrigin="anonymous"
                                        src={`https://rrgold.loyalstring.co.in/${image}`}
                                        // src='https://images.unsplash.com/photo-1542332213-9b5a5a3fad35?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8fA%3D%3D'
                                        alt={`${item?.item} Image ${index + 1}`}
                                        style={{
                                          width: "100%",
                                          height: "180px",
                                          objectFit: "cover",
                                          borderRadius: "10px",
                                          transition: "transform 0.3s",
                                        }}
                                          
                                        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                                        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                      />
                                    </div>
                                  ))}
                                </Slider>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "180px",
                                    width: "100%",
                                    background: "#f5f5f5",
                                    borderRadius: "10px",
                                   padding: "20px"
                                  }}
                                >
                                  <FaImage size={80} color="#ccc" />
                                </div>
                              )}


                            </div>
                      
                            {/* Product Info */}
                            <div style={{ marginTop: "10px", width: "100%", textAlign: "center" }}>
                              <p style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>
                                <strong>Gross:</strong> {item.GrossWt}
                              </p>
                              <p style={{ fontSize: "14px", color: "#555" }}>
                                <strong>SKU:</strong> {item.SKU}
                              </p>
                              <p style={{ fontSize: "14px", color: "#555" }}>
                                <strong>Item Code:</strong> {item.ItemCode}
                              </p>
                              <p style={{ fontSize: "14px", color: "#555" }}>
                                <strong>RFID:</strong> {item.RFIDCode}
                              </p>
                            </div>
                          </div>
                    );
                  })
                : []}
            </div>
          </>
        ) : (
          <LabelledStockListNew
            columns={stockListColumns}
            allCategories={list?.length ? list : []}
            // allCategories={filteredData ? filteredData : []}
            handleEditData={(product) =>
              navigate(`/edit_stock_labelled_unlabelled/${product?.Id}`)
            }
            searchInput={""}
            setSearchInput={() => {}}
            disableHead={true}
            handlePrint={(product) => {
              printLabel([product]);
            }}
            setSelectedAll={setSelectedAll}
            disablePagination={true}
            totalData={list?.length}
            PageNumber={PageNumber}
            PageSize={PageSize}
          />
        )}

        {/* Pagination */}
        {/* {list?.length ? (
          <div
            className={style["page-controls"]}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              fontSize: "8px",
            }}
          >
            <div className={style["rows-per-page"]}>
              <label htmlFor="rows-per-page">Rows per page</label>
              <select
                id="rows-per-page"
                value={PageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>

            <div className={style["pagination"]}>
              <button
                disabled={PageNumber === 1}
                onClick={() => setPageNumber((prev) => prev - 1)}
              >
                Prev
              </button>

              {generatePagination().map((page, index) =>
                page === "..." ? (
                  <span key={index} className={style.dots}>
                    ...
                  </span>
                ) : (
                  <button
                    key={index}
                    className={
                      PageNumber === page
                        ? style["pagination-pages-active"]
                        : style["pagination-pages"]
                    }
                    onClick={() => setPageNumber(page)}
                  >
                    {page}
                  </button>
                )
              )}

              <button
                disabled={PageNumber === totalPages}
                onClick={() => setPageNumber((prev) => prev + 1)}
              >
                Next
              </button>

              <input
                type="number"
                value={InputPageNumber}
                min={1}
                max={totalPages}
                onChange={(e) => {
                  const pageNum = Number(e.target.value);
                  if (pageNum >= 1 && pageNum <= totalPages) {
                    setInputPageNumber(pageNum);
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    const pageNum = Number(e.target.value);
                    if (pageNum >= 1 && pageNum <= totalPages) {
                      setInputPageNumber(pageNum);
                    }
                  }
                }}
                style={{
                  width: "40px",
                  marginLeft: "8px",
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />
            </div>
          </div>
        ) : (
          ""
        )} */}
      </div>
    </>
  );
}
